const TYPES_VIEWS = {
  LOGIN: "LOGIN",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  SET_PASSWORD_FORGOT: "SET_PASSWORD_FORGOT",
  ACCEPT_TERMS: "ACCEPT_TERMS",
  LOADING: "LOADING",
  STEP_6: "STEP_6",
  STEP_7: "STEP_7",
};

export default TYPES_VIEWS;
